export default "__VITE_ASSET__ea6ffb76__"